import { Button, EpicIcons } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { createReminderElementButton_CreateReminderElementMutation } from "@relay/createReminderElementButton_CreateReminderElementMutation.graphql";
import { CREATE_REMINDER_ELEMENT_MUTATION } from "./create-reminder-element-button.graphql";
import { type CreateReminderElementButtonProps } from "./create-reminder-element-button.types";
import { useDraftStatusUpdater } from "../use-draft-status-updater";

export const CreateReminderElementButton = ({
	eLearningContentNodeId,
}: CreateReminderElementButtonProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [createReminderElement, isCreatingReminderElement] =
		useMutation<createReminderElementButton_CreateReminderElementMutation>(
			CREATE_REMINDER_ELEMENT_MUTATION,
		);

	const handleCreateReminderElementOnClick = () => {
		createReminderElement({
			variables: {
				input: {
					title: t("educationalOffer.newReminderElement"),
					text: t("educationalOffer.newText"),
					eLearningContentNodeId: eLearningContentNodeId,
				},
			},
			updater: setDraft,
		});
	};

	return (
		<Button
			disabled={isCreatingReminderElement}
			tooltip={t("educationalOffer.createReminderElementTooltip")}
			icon={EpicIcons.CLOCK}
			onClick={handleCreateReminderElementOnClick}
		/>
	);
};
